// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image.cover[data-v-d71dc354],.image.cover>img[data-v-d71dc354]{height:100%;width:100%}.image.cover>img[data-v-d71dc354]{-o-object-fit:cover;object-fit:cover;-o-object-position:center;object-position:center;position:absolute}.image.rounded[data-v-d71dc354],.image.rounded>img[data-v-d71dc354]{border-radius:9999px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
